export default __webpack_public_path__ + "static/media/number-shine-6.ad65640f.svg";